import { OPEN_TASK_STATUSES } from './taskHelpers'
import type { TaskSearchRequest } from '@/composables/services/useTasksApi'

const OPEN_STATUS_FILTER = { op: 'in', value: OPEN_TASK_STATUSES }

function endOfTodayIso(): string {
  const d = new Date()
  d.setHours(23, 59, 59, 999)
  return d.toISOString()
}

export interface TaskViewContext {
  userId: string
  orgId: string
  teamIds: string[]
}

export function buildTaskViewRequest(
  viewId: 'my-tasks' | 'my-tasks-due-today' | 'team-tasks' | 'all-tasks',
  ctx: TaskViewContext,
  pagination: { limit: number; start: number },
): TaskSearchRequest {
  const common = { sort: 'dueDate_asc', pagination }

  switch (viewId) {
    case 'my-tasks':
      return {
        ...common,
        filters: {
          orgId: ctx.orgId,
          ownerUserId: ctx.userId,
          status: OPEN_STATUS_FILTER,
        },
      }
    case 'my-tasks-due-today':
      return {
        ...common,
        filters: {
          orgId: ctx.orgId,
          ownerUserId: ctx.userId,
          status: OPEN_STATUS_FILTER,
          dueDate: { op: 'le', value: endOfTodayIso() },
        },
      }
    case 'team-tasks':
      return {
        ...common,
        filters: {
          orgId: ctx.orgId,
          ownerTeamId: { op: 'in', value: ctx.teamIds },
          unassignedUser: true,
          status: OPEN_STATUS_FILTER,
        },
      }
    case 'all-tasks':
      return {
        ...common,
        filters: {
          orgId: ctx.orgId,
          status: OPEN_STATUS_FILTER,
        },
      }
  }
}
